import { Node_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1/index.js";
import { TiptapContentResolver } from "./../../toolbars-v3/ContentResolver.js";
const getHeadingInSelection = TiptapContentResolver.create((content) => {
  if (Array.isArray(content) && content.length > 0) {
    const headingLevel = content.find((node) => node.type.name === Node_Type.HEADING)?.attrs?.level;
    if (!headingLevel || content[0].type.name === Node_Type.PARAGRAPH) return "unstyled";
    const headingMap = {
      1: "header-one",
      2: "header-two",
      3: "header-three",
      4: "header-four",
      5: "header-five",
      6: "header-six"
    };
    return headingMap[headingLevel];
  } else {
    return void 0;
  }
});
export {
  getHeadingInSelection
};
//# sourceMappingURL=get-heading-in-selection.js.map
